import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { GlobalConstants } from '../constant/constant';
import { environment } from 'src/environments/environment';

// intercept each API request and if available inject the AccessToken
// without having to include this in each service call

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.get('Request-Type') === 'arcgis') {
      return next.handle(request);
    } else {
      const due = GlobalConstants.CALL_DUE_TIME_MS; // milliseconds. when is the call 'due' to return?
      // add authorization header with jwt token if available
      const applicationUser = JSON.parse(
        localStorage.getItem(GlobalConstants.USER_KEY)
      );

      let headers: any = {
        setHeaders: {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': environment.apimSubscriptionKey,
        },
      };

      const requstURL: string = request.url;

      if (requstURL.indexOf('blob.core') > 0) {
        if (request.headers.get('Request-Type') === 'commit') {
          request = request.clone(headers);
          return next.handle(request).pipe(timeout(due));
        }
        headers = { setHeaders: { 'x-ms-blob-type': 'BlockBlob' } };
      } else if (applicationUser && applicationUser.AccessToken) {
        headers['setHeaders']['Authorization'] =
          'Bearer ' + applicationUser.AccessToken;
      }

      request = request.clone(headers);
      return next.handle(request).pipe(timeout(due));
    }
  }
}
